import * as React from "react";
import Typography from "@material-ui/core/Typography";
import { useTypedSelector } from "../../state/store";
import { SpaciousPaper, WhiteSpacePreservingTypography } from "../styleComponents";

var PeerReviewOption = function PeerReviewOption(_a) {
  var answer = _a.answer;
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });

  if (!quiz) {
    return React.createElement("div", null);
  }

  var quizItems = quiz.items;

  var quizItemById = function quizItemById(id) {
    return quizItems.find(function (qi) {
      return qi.id === id;
    });
  };

  return React.createElement("div", {
    style: {
      padding: ".5rem 1rem"
    }
  }, answer.itemAnswers.filter(function (ia) {
    var item = quizItemById(ia.quizItemId);
    return !item || item.type === "essay";
  }).sort(function (ia1, ia2) {
    var qi1 = quizItemById(ia1.quizItemId);
    var qi2 = quizItemById(ia2.quizItemId);

    if (!qi1 || !qi2) {
      return -1;
    }

    return qi1.order - qi2.order;
  }).map(function (ia) {
    var quizItem = quizItemById(ia.quizItemId);
    var quizTitle = quizItem ? quizItem.texts[0].title : "";
    return React.createElement(React.Fragment, {
      key: ia.id
    }, React.createElement(Typography, {
      variant: "subtitle2"
    }, quizTitle), React.createElement(SpaciousPaper, {
      key: ia.id
    }, React.createElement(WhiteSpacePreservingTypography, {
      variant: "body1"
    }, ia.textData)));
  }));
};

export default PeerReviewOption;